<script setup lang="ts">
import { Separator } from "~/components/ui/separator"
import { useBrandedPageMeta } from "~/composables/brandedPageMeta"
import { generateTermsOfUse } from "./utils/termsOfUse"

useBrandedPageMeta("Terms of Use")

const termsOfUseHTML = generateTermsOfUse()
</script>

<template>
    <section class="w-full flex flex-col gap-10 md:gap-12 max-w-5xl mx-auto px-4 md:px-6 py-32">
        <header class="space-y-4 text-center">
            <h1 class="text-3xl md:text-4xl font-headline">
                Terms of Use
            </h1>
            <Separator class="w-10 mx-auto bg-foreground" />
            <p>
                Last updated: August 19, 2026
            </p>
        </header>
        <div
            class="flex flex-col gap-3 md:gap-4 prose prose-sm max-w-none" 
            v-html="termsOfUseHTML"
        />
    </section>
</template>
